<script>
import Config from '@/config';
import FormMinx from '@/mixins/form';
import AdminMinx from '@/mixins/admin';
import {Popup, DatetimePicker, Uploader, Toast} from 'vant';
import {getStationBaseInfo, createStationRepairRecord, getStationRepairRecordDetail} from '@/api';

export default {
  mixins: [
    FormMinx,
    AdminMinx
  ],
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      stationName: '',
      troubleDevice: null,
      deviceCode: null,
      troubleAt: null,
      troubleReason: null,
      repairRecord: null,
      repairPeople: null,
      repairResult: null,
      finishAt: null,
      images: [],
      recordPeople: null,
    };
  },
  computed: {
    repairId() {
      return this.$route.params.repairId;
    },
    stationCode() {
      return this.$route.params.stationCode;
    },
    readonly() {
      return !!this.$route.params.repairId;
    }
  },
  watch: {
    stationCode(value) {
      this.loadStationData(value);
    },
    repairId(value) {
      this.loadRepairData(value);
    }
  },
  created() {
    this.loadStationData(this.stationCode);
    this.loadRepairData(this.repairId);
  },
  methods: {
    loadStationData(value) {
      if (value) {
        getStationBaseInfo(value).then(response => {
          this.stationName = response.data.body.name;
        });
      } else {
        this.stationName = null;
      }
    },
    loadRepairData(value) {
      this.showDatetimePicker = false;

      if (value) {
        getStationRepairRecordDetail(value).then(response => {
          this.troubleDevice = response.data.body.troubleDevice;
          this.deviceCode = response.data.body.deviceCode;
          this.troubleAt = response.data.body.troubleAt;
          this.troubleReason = response.data.body.troubleReason;
          this.repairRecord = response.data.body.repairRecord;
          this.repairPeople = response.data.body.repairPeople;
          this.repairResult = response.data.body.repairResult;
          this.finishAt = response.data.body.finishAt;
          this.images = response.data.body.images ? response.data.body.images.split(',').map(url => {
            return {url: url, isImage: true, deletable: !this.readonly};
          }) : [];
          this.recordPeople = response.data.body.recordPeople;
        });
      } else {
        this.troubleDevice = null;
        this.deviceCode = null;
        this.troubleAt = null;
        this.troubleReason = null;
        this.repairRecord = null;
        this.repairPeople = null;
        this.repairResult = null;
        this.finishAt = null;
        this.images = [];
        this.recordPeople = null;
      }
    },
    onSubmit(values) {
      let operate = this.repairId ? '更新' : '添加';
      createStationRepairRecord(this.stationCode, Object.assign(values, {id: this.repairId, images: values.images.map(v => v.objectKey).join(',')})).then(response => {
        if (response.data.code === Config.successCode) {
          Toast(operate + '维修记录成功');
          this.$router.go(-1);
        } else {
          Toast(operate + '维修记录失败');
        }
      }).catch(() => Toast(operate + '维修记录失败'));
    },
    showTroubleAtDatetimePicker() {
      if (this.readonly) {
        return;
      }

      this.showDatetimePicker = true;
      this.currentDatetimePickerField = 'troubleAt';
    },
    showFinishAtDatetimePicker() {
      this.showDatetimePicker = true;
      this.currentDatetimePickerField = 'finishAt';
    },
    datetimePickerOnConfirm(datetime) {
      this.showDatetimePicker = false;
      if (this.currentDatetimePickerField === 'troubleAt') {
        this.troubleAt = datetime.format('yyyy-MM-dd hh:mm');
      } else if (this.currentDatetimePickerField === 'finishAt') {
        this.finishAt = datetime.format('yyyy-MM-dd hh:mm');
      }
    }
  }
}
</script>

<template>
  <van-form @submit="onSubmit" :show-error-message="false">
    <div class="row-title">{{ stationName }}</div>
    <van-field v-model="troubleDevice" name="troubleDevice" label="故障设备" placeholder="请填写故障设备" :rules="[{ required: true, message: '故障设备不能为空'}]" :readonly="readonly" showWordLimit/>
    <van-field v-model="deviceCode" name="deviceCode" label="设备编号" placeholder="请填写设备编号" :readonly="readonly"/>
    <van-field :value="troubleAt" name="troubleAt" label="故障时间" placeholder="点击选择故障时间" @click="showTroubleAtDatetimePicker" :readonly="readonly" clickable/>
    <van-field v-model="troubleReason" name="troubleReason" label="故障原因" placeholder="请填写故障原因" :rules="[{ required: true, message: '故障原因不能为空'}]" :readonly="readonly"/>
    <van-field v-model="repairRecord" name="repairRecord" label="维修记录" placeholder="请填写维修记录"/>
    <van-field v-model="repairPeople" name="repairPeople" label="维修人员" placeholder="请填写维修人员"/>
    <van-field v-model="repairResult" name="repairResult" label="维修结果" placeholder="请填写维修结果"/>
    <van-field :value="finishAt" name="finishAt" label="完成时间" placeholder="点击选择完成时间" @click="showFinishAtDatetimePicker" :rules="[{ validatorDatetime }]" clickable/>
    <div class="row-title-small">上传照片</div>
    <van-field name="images" label-width="0">
      <template #input>
        <van-uploader v-model="images" :before-read="uploadBeforeRead" :after-read="uploadAfterRead" :before-delete="uploadBeforeDelete" :deletable="!readonly" multiple/>
      </template>
    </van-field>
    <van-field name="recordPeople" :value="recordPeople ? recordPeople : mobile" label="登记人员" :deletable="!readonly"/>
    <div class="from-submit">
      <van-button round block type="info" native-type="submit">提交</van-button>
    </div>
    <van-popup v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker type="datetime" :min-date="minDate" :max-date="maxDate" @confirm="datetimePickerOnConfirm" @cancel="showDatetimePicker = false" :formatter="datetimeFormatter"/>
    </van-popup>
  </van-form>
</template>

<style scoped>

</style>